import * as React from 'react'
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

const ProjectorModal = ({ closeModal }) => {
  const { modalRef } = useModalAccessibility(closeModal);

  return (
    <div className="projector-modal-container">
      <div className="projector-modal-background" />
      <div
        aria-labelledby="projector-modal-title"
        aria-modal="true"
        className="projector-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id="projector-modal-title">Project this window</h2>
          <p>Set your computer&apos;s display settings so that you can project the slides to students while keeping the lesson plan and student responses on your computer.</p>
          <p>Once you&apos;ve adjusted your display settings, drag the window you want to project all the way to the left or right until it appears on the projector.</p>
        </div>
        <div className="display-settings-box">
          <p className="display-settings-header">How to adjust your display settings?</p>
          <div className="display-settings-columns">
            <div className="display-settings-column">
              <p className="column-header">For Windows:</p>
              <ol>
                <li>Go to Control Panel or right-click on your desktop</li>
                <li>Select Display settings</li>
                <li>Click the Multiple displays dropdown</li>
                <li>Select Extend these displays</li>
              </ol>
            </div>
            <div className="display-settings-column">
              <p className="column-header">For Macs:</p>
              <ol>
                <li>Go to System Preferences</li>
                <li>Go to Displays</li>
                <li>Select the Arrangement tab</li>
                <li>Uncheck Mirror Displays</li>
              </ol>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="quill-button contained green medium focus-on-light" onClick={closeModal} type="button">Got it</button>
        </div>
      </div>
    </div>
  )
}

export default ProjectorModal
